module.exports = __webpack_public_path__ + "static/media/check-circle-icon.34a9e34e.svg";